// Module
var code = "<li id class=\"floorplan-tab\"><a href=\"#\" class=\"floorplan-tab-link\"></a></li>";
// Exports
module.exports = code;